export const styleSheet = () => ({
    container: {
        borderRadius: 3.5,
        boxShadow: '0 10px 10px 0 rgba(0, 0, 0, 0.2)',
        svg: {
            marginLeft: '0 !important' // overwrite TooltipForm's button svg styles to keep it centered
        }
    }
});
